// Program Yap — giriş ekranı: "Beni hatırla" davranışı.
//
// Core'un login.js'ine DOKUNMAZ; sadece DOM'a bir onay kutusu ekler ve kendi
// submit dinleyicisini takar (core'unki çalışmaya devam eder).
//
// NE YAPAR: kutu işaretliyse e-posta adresi tarayıcıda saklanır ve bir dahaki
// açılışta alan hazır gelir. Kutu işaretli değilse kayıt SİLİNİR.
//
// NE YAPMAZ: oturumu açık TUTMAZ. Frappe'de oturum ömrü site geneli tek bir
// ayardır (System Settings → session_expiry); giriş başına "oturumu uzat"
// seçeneği YOKTUR. Şifre asla saklanmaz.

(function py_login() {
	const KEY = "py_remember_email";

	function ready(fn) {
		if (document.readyState !== "loading") fn();
		else document.addEventListener("DOMContentLoaded", fn);
	}

	ready(function () {
		const form = document.querySelector(".form-login");
		const email = document.getElementById("login_email");
		if (!form || !email) return; // giriş formu yoksa (ör. şifre sıfırlama sayfası)

		// --- Buton metni ---
		// Core butona "Continue" yazar. Bunu çeviri sözlüğünde değiştiremeyiz:
		// "Continue" Frappe'de sihirbaz/diyalog gibi ONLARCA yerde geçer, global
		// çeviri onları da bozardı. Bu yüzden SADECE bu sayfada, burada ayarlıyoruz.
		// Buton form'un İÇİNDE (email_login_body makrosu → .page-card-actions).
		// LDAP butonunu atla — onun kendi metni var.
		const submitBtn = form.querySelector('.btn-login[type="submit"]:not(.btn-ldap-login)');
		if (submitBtn) submitBtn.textContent = "Giriş yap";

		// --- Onay kutusunu, core'un "Şifremi unuttum" linkiyle aynı satıra al ---
		const forgot = form.querySelector(".forgot-password-message");

		const row = document.createElement("div");
		row.className = "py-login__row";

		const label = document.createElement("label");
		label.className = "py-login__remember";

		const box = document.createElement("input");
		box.type = "checkbox";
		box.id = "py_remember";

		const text = document.createElement("span");
		// frappe.__ yoksa düz metne düş (giriş ekranında frappe global'i yüklü olur).
		text.textContent =
			(window.frappe && window.frappe.__ && window.frappe.__("Beni hatırla")) || "Beni hatırla";

		label.appendChild(box);
		label.appendChild(text);
		row.appendChild(label);

		if (forgot) {
			// Linki satıra TAŞI (kopyalama — iki tane görünmesin).
			row.appendChild(forgot);
		}

		// Satırı şifre alanının hemen ardına koy; yoksa formun sonuna.
		const pwGroup = email.closest(".page-card-body");
		if (pwGroup) pwGroup.appendChild(row);
		else form.appendChild(row);

		// --- Hatırlanan e-postayı geri yükle ---
		let saved = null;
		try {
			saved = localStorage.getItem(KEY);
		} catch (e) {
			saved = null; // özel sekme / storage kapalı → sessizce geç
		}
		if (saved) {
			email.value = saved;
			box.checked = true;
			// E-posta hazırsa odağı şifreye al — kullanıcı direkt yazsın.
			const pw = document.getElementById("login_password");
			if (pw) pw.focus();
		}

		// --- Submit'te kaydet/sil. Core'un submit'i ayrı dinleyici; bu onu engellemez. ---
		form.addEventListener("submit", function () {
			try {
				if (box.checked) localStorage.setItem(KEY, (email.value || "").trim());
				else localStorage.removeItem(KEY);
			} catch (e) {
				/* storage yazılamıyorsa giriş yine de devam etsin */
			}
		});
	});
})();
